import { LocalStoreKeys } from "../constant/enum/LocalStoreKeys";
import { RollFormater } from "../constant/enum/UserRolls";

export const getUserRoll = () => {
  const userData = JSON.parse(localStorage?.getItem(LocalStoreKeys.profile));

  const userRoles = userData
    ? typeof userData?.Access === "string"
      ? userData?.Access
      : userData?.Access[0]
    : null;

  const userAbility = userData
    ? typeof userRoles === "string"
      ? [userRoles]
      : Object.keys(userRoles).map((keyRoll) => {
          if (userRoles[keyRoll] === "on") return keyRoll;
          else return;
        })
    : [];

  const avaibleAbility = userAbility?.filter(
    (ability) => ability !== undefined
  );

  const convertRollFormat = (rolls) => {
    return rolls.map((roll) => RollFormater[roll]);
  }

  return avaibleAbility?.length > 0 ? convertRollFormat(avaibleAbility) : [];
};
